// extracted by mini-css-extract-plugin
module.exports = {"reschedule-page__title":"_1gWlhJMITaiBc_IwN0rpsL","reschedule-page__row":"_1KNCfJtvnVU1ofCeWRdXug"};